import { USER_SETTINGS_AUDIO_KEY } from './constants';

// Original type definition
type UserSettingKeys = {
  type: typeof USER_SETTINGS_AUDIO_KEY;
  enabled: boolean;
};

// Extract the 'type' property values from the UserSettingKeys union
type SettingType = UserSettingKeys['type'];

export function setUserSetting(setting: UserSettingKeys) {
  switch (setting.type) {
    case USER_SETTINGS_AUDIO_KEY:
      localStorage.setItem(setting.type, setting.enabled ? 'true' : 'false');
      break;

    default:
      break;
  }
}

// Updated to accept only USER_SETTINGS_AUDIO_KEY
export function getUserSetting(key: SettingType): boolean {
  switch (key) {
    case USER_SETTINGS_AUDIO_KEY: {
      const result = localStorage.getItem(key);

      if (!result) {
        // NOTE: Default to true if no setting is found
        setUserSetting({ type: USER_SETTINGS_AUDIO_KEY, enabled: true });
        return true;
      }
      return result === 'true' ? true : false;
    }

    default:
      return false;
  }
}
